import { render, staticRenderFns } from "./CalendarV2.vue?vue&type=template&id=830feeb4&scoped=true&"
import script from "./CalendarV2.vue?vue&type=script&lang=ts&"
export * from "./CalendarV2.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarV2.vue?vue&type=style&index=0&id=830feeb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830feeb4",
  null
  
)

export default component.exports